import { Body1, Body2 } from 'stories/elements/Typography/Text'
import Stack from 'components/elements/Stack'
import { Region } from 'interfaces/Region'
import { parseLocale } from 'lib/constants/localization'
import theme from 'stories/utils/theme'
import _useTranslation from 'lib/hooks/_useTranslation'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { trackPromise } from 'react-promise-tracker'
import { ApiError } from 'services/ApiService'
import RegionService from 'services/RegionService'
import styled, { css } from 'styled-components'
import Row from 'components/elements/Row'

const SelectionCard = styled.div<{ isDarkTheme?: boolean }>`
    width: 100%;
    cursor: pointer;
    border: 2px solid ${({ isDarkTheme }) => (isDarkTheme ? theme.colors.transparent : theme.colors.outlineGray)};
    border-radius: ${theme.borderRadius.normal};
    padding: 20px;
    ${({ isDarkTheme }) =>
        isDarkTheme
            ? css`
                  background-color: ${theme.colors.backgroundTransparent};
                  &:hover {
                      background-color: ${theme.colors.backgroundTransparent};
                  }
              `
            : ''}
    & p {
        margin: 0;
    }

    img {
        width: 30px;
        height: auto;
    }
`

interface Props {
    handleRegionSelect: (region: Region) => void
    isDarkTheme?: boolean
}

const GradeSelectionRegion = ({ handleRegionSelect, isDarkTheme }: Props) => {
    const [regions, setRegions] = useState<Region[]>([])

    const { locale } = useRouter()
    const parsedLocale = parseLocale(locale)

    const { t } = _useTranslation('knows')
    const { t: tCommon } = _useTranslation('common')

    useEffect(() => {
        trackPromise(
            RegionService.listRegionsByCountry(parsedLocale.countryCode)
                .then((regions) => {
                    if (regions?.length === 1 && regions[0].isDefault) {
                        handleRegionSelect(regions[0])
                    }
                    setRegions(regions)
                })
                .catch((error) => {
                    if (error instanceof ApiError) {
                        error.handleUnknownError(tCommon, 'region.listRegionsByCountry')
                    } else {
                        throw error
                    }
                })
        )
    }, [handleRegionSelect, parsedLocale.contentLanguageCode, parsedLocale.countryCode, tCommon])

    return (
        <Stack>
            <Body2 color={isDarkTheme ? theme.colors.grayScaleSecondary : theme.colors.body1Black}>
                {t('knows/createDetailsGradeSelectionDialogChooseRegion')}
            </Body2>
            {regions.map((region) => (
                <SelectionCard key={region.id} onClick={() => handleRegionSelect(region)} isDarkTheme={isDarkTheme}>
                    <Row>
                        <img src={region.iconUrl} alt="" />
                        <Body1
                            fontFamily="var(--font-inter)"
                            color={isDarkTheme ? theme.colors.grayScaleSecondary : theme.colors.subtitleBlack}
                            fontWeight={500}
                        >
                            {region.regionName}
                        </Body1>
                    </Row>
                </SelectionCard>
            ))}
        </Stack>
    )
}

export default GradeSelectionRegion
